import './Error.css'
import { useTranslation } from 'react-i18next';
function Error(){
  const { t } = useTranslation();
  return(
    <div className="error-container container">
      <div className="error-content content">
        <h1 className='error'>404</h1>
        <h2 className='error'>{t('oopssSorry')}</h2>
        <p>{t('errorDesc')}</p>
      </div>
    </div>
  )
}
export default Error